import React from 'react';

import {
  CmBox,
  CmButton,
  CmDatePicker,
  CmFlex,
  CmFormLabel,
  CmSelect,
  SearchIcon,
} from '@/components/uiParts';
import { StoreFilter } from '@/pages/externals/mos-pos-resend/index/components/StoreFilter';
import {
  deliveryServiceOptions,
  FilterForm,
} from '@/pages/externals/mos-pos-resend/service';
import { MosPosStore } from '@/services/MosPosOrder/type';

type Props = {
  form: FilterForm;
  stores: MosPosStore[];
  isLoadingStores: boolean;
  hasStoreError: boolean;
  isSearching: boolean;
  onChangeAuthStoreId: (value: number | null) => void;
  onChangeDeliveryServiceId: (value: string) => void;
  onChangeOrderDateStart: (date: Date) => void;
  onChangeOrderDateEnd: (date: Date) => void;
  onSearch: () => void;
};

/** 検索条件のラベル (テンプレートの .filter-item label に合わせる) */
const FilterLabel: React.FC<{ htmlFor: string }> = ({ htmlFor, children }) => (
  <CmFormLabel
    htmlFor={htmlFor}
    fontSize="12px"
    fontWeight="bold"
    color="gray.600"
    mb="6px"
  >
    {children}
  </CmFormLabel>
);

export const SearchFilter: React.VFC<Props> = ({
  form,
  stores,
  isLoadingStores,
  hasStoreError,
  isSearching,
  onChangeAuthStoreId,
  onChangeDeliveryServiceId,
  onChangeOrderDateStart,
  onChangeOrderDateEnd,
  onSearch,
}) => {
  return (
    <CmFlex alignItems="flex-end" gridGap="18px" flexWrap="wrap">
      <CmBox width="266px">
        <FilterLabel htmlFor="mos-pos-resend-auth-store">店舗</FilterLabel>
        <StoreFilter
          stores={stores}
          isLoading={isLoadingStores}
          hasError={hasStoreError}
          value={form.authStoreId}
          onChange={onChangeAuthStoreId}
        />
      </CmBox>

      <CmBox width="150px">
        <FilterLabel htmlFor="mos-pos-resend-delivery-service">
          デリバリーサービス
        </FilterLabel>
        <CmSelect
          id="mos-pos-resend-delivery-service"
          value={form.deliveryServiceId}
          onChange={(event) => onChangeDeliveryServiceId(event.target.value)}
        >
          {deliveryServiceOptions.map((option) => (
            <option key={option.label} value={option.value}>
              {option.label}
            </option>
          ))}
        </CmSelect>
      </CmBox>

      {/*
        日付は「YYYY/MM/DD」+ カレンダーアイコン分の幅が要る。

        開始 > 終了 の組み合わせは API が 400
        (order_date_end must not be earlier than order_date_start) を返し、
        画面には原因の分からない共通エラートーストしか出ない。
        そのため maxDate / minDate で互いを上限・下限にし、
        カレンダー上で逆順を選べないようにしている。
      */}
      <CmBox width="160px">
        <FilterLabel htmlFor="mos-pos-resend-order-date-start">
          注文日（開始）
        </FilterLabel>
        <CmDatePicker
          id="mos-pos-resend-order-date-start"
          selectedDate={form.orderDateStart}
          maxDate={form.orderDateEnd}
          onChange={onChangeOrderDateStart}
        />
      </CmBox>

      <CmBox width="160px">
        <FilterLabel htmlFor="mos-pos-resend-order-date-end">
          注文日（終了）
        </FilterLabel>
        <CmDatePicker
          id="mos-pos-resend-order-date-end"
          selectedDate={form.orderDateEnd}
          minDate={form.orderDateStart}
          onChange={onChangeOrderDateEnd}
        />
      </CmBox>

      {/*
       // @ts-ignore TS2590 */}
      <CmButton
        leftIcon={<SearchIcon />}
        isLoading={isSearching}
        onClick={onSearch}
      >
        検索
      </CmButton>
    </CmFlex>
  );
};
